export function activeViewSelector(state) {
  return state.view.active;
}
export function viewDataSelector(state) {
  return state.view.data;
}
export function activeFlowSelector(state) {
  return state.activeFlow;
}